




import { defineComponent, onMounted } from '@vue/composition-api';

import { useRouter } from '@ideavivat/vivat-2';

const Logout = defineComponent({
  setup() {
    const { router } = useRouter();

    onMounted(async () => {
      router.push({ name: 'Login' });
    });
  },
});

export default Logout;
